import {
  PROFILE_BANNER_TEXT_DEFAULT,
  type ProfileBannerFacts,
  type ProfileBannerText,
} from 'fym-shared/src/music24/profileBanner';
import type { ArtistProfileResponse, SerializedProfileAsset } from 'fym-shared/src/music24/artistProfile';
import type { ProfileRelease } from '../profileReleases';
import type { ProfileToolDraft } from './profileToolDraft';

/**
 * The text of the banners in the tool preview (design profile-card b): the facts that the server
 * will write (the release of a cover source, else the next or newest release of the profile
 * answer) and the variant of the draft. Pure.
 */

/** The first variant of the banners tool: the variant of the current banner, else of the profile, else the default. */
export function initialBannerText(
  current: SerializedProfileAsset | null,
  profile: Pick<ArtistProfileResponse, 'bannerText'>
): ProfileBannerText {
  return current?.bannerText ?? profile.bannerText?.variant ?? PROFILE_BANNER_TEXT_DEFAULT;
}

/**
 * The facts that the preview shows. A cover source names its own release (its date says
 * whether the banner asks for the pre-save); else the facts of the profile answer. Null with an
 * older API that sends no facts.
 */
export function previewBannerFacts(
  profile: Pick<ArtistProfileResponse, 'bannerText'>,
  draft: Pick<ProfileToolDraft, 'source'>,
  release: ProfileRelease | undefined
): { facts: ProfileBannerFacts; today: string } | null {
  const base = profile.bannerText;
  if (base === undefined) {
    return null;
  }
  if (
    draft.source !== 'cover' ||
    release === undefined ||
    release.catalogItemUuid === base.facts.release?.catalogItemUuid
  ) {
    return { facts: base.facts, today: base.today };
  }
  const releaseDate = release.releaseDate === null ? null : release.releaseDate.slice(0, 10);
  return {
    today: base.today,
    facts: {
      ...base.facts,
      release: {
        catalogItemUuid: release.catalogItemUuid,
        title: release.title,
        releaseDate,
        released: releaseDate !== null && releaseDate <= base.today,
      },
    },
  };
}
